import React from "react";
import { SelectInput } from "react-admin";
import moment from "moment";
import { get } from "lodash";
const DayInput = (props) => {
  let choices = [
    moment().subtract(1, "month").startOf("month"),
    moment().startOf("month"),
  ];
  let day = moment(get(props, "record.day"));
  if (day.isBefore(moment().subtract(2, "months"))) {
    choices.push(day);
  }

  return (
    <SelectInput
      {...props}
      choices={choices.map((id) => ({
        id: `${id.format("YYYY-MM-DD")}T00:00:00+00:00`,
        name: id.format("MMMM YYYY"),
      }))}
    />
  );
};
export default DayInput;
